// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__uTKLt","filesListContainer":"PosDisputesFiles_filesListContainer__cfSI_","filesButton":"PosDisputesFiles_filesButton__3Ki7U"};